export default "__VITE_ASSET__DuNcxlnQ__"